import { SyncError, SyncManager } from 'db';
import { useEffect, useState } from 'react';

export function useSyncManagerState(syncManager: SyncManager) {
  const [isSyncing, setIsSyncing] = useState(syncManager.isSyncing);
  const [pendingSync, setPendingSync] = useState(syncManager.pendingSync);
  const [isBusy, setIsBusy] = useState(syncManager.isBusy);
  const [consecutiveFailures, setConsecutiveFailures] = useState(syncManager.consecutiveFailures);
  const [lastError, setLastError] = useState<SyncError | null>(syncManager.lastError);

  useEffect(() => {
    const handleChange = () => {
      setIsSyncing(syncManager.isSyncing);
      setPendingSync(syncManager.pendingSync);
      setIsBusy(syncManager.isBusy);
      setConsecutiveFailures(syncManager.consecutiveFailures);
      setLastError(syncManager.lastError);
    };

    syncManager.on('stateChange', handleChange);
    handleChange(); // initialize
    return () => {
      syncManager.off('stateChange', handleChange);
    };
  }, [syncManager]);

  return { isSyncing, pendingSync, isBusy, consecutiveFailures, lastError };
}
